import React from 'react';
import { i18nService } from '../../services/i18n';

type CoworkPromptMode = 'collaboration' | 'quick';

interface CoworkPromptModeSwitchProps {
  value: CoworkPromptMode;
  onChange: (mode: CoworkPromptMode) => void;
  className?: string;
}

const PROMPT_MODE_OPTIONS: Array<{
  mode: CoworkPromptMode;
  labelKey: string;
  descriptionKey: string;
}> = [
  { mode: 'quick', labelKey: 'coworkPromptModeChat', descriptionKey: 'coworkPromptModeQuickHint' },
  { mode: 'collaboration', labelKey: 'coworkPromptModeWork', descriptionKey: 'coworkPromptModeCollabHint' },
];

const CoworkPromptModeSwitch: React.FC<CoworkPromptModeSwitchProps> = ({ value, onChange, className }) => {
  const activeIndex = Math.max(0, PROMPT_MODE_OPTIONS.findIndex((option) => option.mode === value));

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    const offset = event.key === 'ArrowRight' ? 1 : -1;
    const nextIndex = (activeIndex + offset + PROMPT_MODE_OPTIONS.length) % PROMPT_MODE_OPTIONS.length;
    onChange(PROMPT_MODE_OPTIONS[nextIndex].mode);
  };

  return (
    <div
      role="radiogroup"
      aria-label={i18nService.t('coworkPromptModeLabel')}
      onKeyDown={handleKeyDown}
      className={`inline-flex items-center rounded-full bg-claude-surfaceHover p-1 dark:bg-claude-darkSurfaceHover${className ? ` ${className}` : ''}`}
    >
      {PROMPT_MODE_OPTIONS.map((option) => {
        const active = option.mode === value;
        return (
          <button
            key={option.mode}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(option.mode)}
            title={i18nService.t(option.descriptionKey)}
            className={`h-10 w-32 rounded-full text-sm font-medium transition-all ${
              active
                ? 'bg-white text-claude-text shadow-sm dark:bg-claude-darkSurface dark:text-claude-darkText'
                : 'text-claude-textSecondary hover:text-claude-text dark:text-claude-darkTextSecondary dark:hover:text-claude-darkText'
            }`}
          >
            {i18nService.t(option.labelKey)}
          </button>
        );
      })}
    </div>
  );
};

export default CoworkPromptModeSwitch;
